import { Environment } from '@util/Environment';
import React, { FunctionComponent, useEffect } from 'react';
import { Route, RouteProps } from 'react-router-dom';
import { AssessmentScreen } from '../config/FlowTypes';
import { skipToPage } from '../helpers/SkipToPage';
import { recordError } from '../util/Errors';
import { Onboard } from './pages/Onboard';

type Props = {
  path: RouteProps['path'];
  page: AssessmentScreen;
};

export const SkipToRoute: FunctionComponent<Props> = (props) => {
  useEffect(
    function initialiseStorePage() {
      skipToPage(props.page);
    },
    [props.page]
  );
  if (Environment.DEVELOPMENT) {
    return (
      <Route exact path={props.path}>
        <Onboard />
      </Route>
    );
  }
  recordError(new Error(`SkipToRoute used in non-development environment, path: '${props.path}'`));
  return null;
};
